// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const pageApi = baseApi.injectEndpoints({
  reducerPath: "pageApi",
  endpoints: (builder) => ({
    getPageById: builder.query({
      query: ({ id }) => {
        return {
          url: `page/${id}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
        },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    updatePage: builder.mutation({
      query: ({ id, modifiedData }) => {
        return {
          url: `page/${id}`,
          method: "PATCH",
          body: modifiedData,
        };
      },
      // invalidatesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetPageByIdQuery, useUpdatePageMutation } = pageApi;
